import type { Components, Theme } from '@mui/material';

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      whiteSpace: 'pre-wrap',
      maxWidth: '350px',
      ...theme.typography.body2,
    }),
  },
  defaultProps: {
    arrow: true,
    placement: 'top',
  },
};
